import { render, staticRenderFns } from "./HeaderSCurve.vue?vue&type=template&id=8a30c658&"
import script from "./HeaderSCurve.vue?vue&type=script&lang=js&"
export * from "./HeaderSCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports